// TODO: fix build so that importing these types doesn't break it

// import { SearchPreset } from '@retro-ui/api-contract';
// import { Config } from '@retro-ui/config';
// batchSearchConfig: Pick<
// Config['global']['batchSearch'],
// 'models' | 'parallelSearchesCount' | 'coldBootTime'
// >,
// searchParams?: SearchPreset | null,

export function estimateSearchTime(
  batchSearchConfig: {
    models: Array<{ id: string; variants: Array<{ length: string; time_per_target?: number }> }>;
    parallelSearchesCount: number;
    coldBootTime: number;
  },
  searchParams?: { model: string; length: string },
  targetsCount?: number | null
) {
  const { models, parallelSearchesCount, coldBootTime } = batchSearchConfig;

  if (!searchParams || !targetsCount) {
    return null;
  }
  const { model, length } = searchParams;

  const existingModel = models?.find(m => m.id === model);
  if (!existingModel || !length) {
    return null;
  }

  const existingVariant = existingModel.variants.find(variant => variant.length === length);
  if (!existingVariant) {
    return null;
  }

  const timePerTarget = existingVariant.time_per_target;
  if (!timePerTarget) {
    return null;
  }

  const searchTimeInSeconds =
    timePerTarget * Math.ceil(targetsCount / parallelSearchesCount) + coldBootTime;
  const searchTimeInMinutes = searchTimeInSeconds / 60;

  if (searchTimeInMinutes > 60) {
    const hours = Math.floor(searchTimeInMinutes / 60);
    const minutes = Math.floor(searchTimeInMinutes % 60);
    return `${hours}h ${minutes}min`;
  }
  return `${searchTimeInMinutes.toFixed()}min`;
}
